module.exports = __webpack_public_path__ + "assets/img/sidenavi/ai-bibi.svg";